<template lang="pug">
  .order
    Loading(v-if="loading")

    template(v-if="order")
      .order-wrapper
        .title Your Order
        .subtitle ID: {{order.uid}}
        .price
          .sum €{{order.amount}} EUR
          .info(v-if="order.subscription") Subscription
        //- .success Thank you for your purchase! Your account is now active.
        //-   img(src="@/assets/success.png")
        .error(v-if="error")
          .message {{error}}
          img(src="@/assets/error.png")
          .info Please try again via a different payment method or contact support: <a href="mailto: cat@filecat.me">cat@filecat.me</a>
        template(v-else)
          ValidationObserver(ref="observer" v-slot="{ passes }")
            .descr {{order.descr}}
            .licensed Licensed to:&nbsp;
              span(v-if="order.email") {{order.email}}
              ValidationProvider(v-else rules="required|email" v-slot="{ errors }" mode="passive")
                input(
                  type="text"
                  name="email"
                  v-model="email"
                  placeholder="enter your email here"
                  :class="{ 'invalid': errors[0] }"
                )
                .input-error {{errors[0]}}
            .subscribe
              button(@click="passes(submit)") SUBSCRIBE NOW
      .processed-by
        img(src="@/assets/fondy.png")
        img(src="@/assets/euro_building.png")
        img(src="@/assets/mastercard_visa.png")

    template(v-else-if="!loading")
      .loading-error
        .error {{error}}
        img(src="@/assets/error.png")
</template>

<script>
import axios from 'axios'
import Loading from '@/components/Loading'

export default {
  components: {
    Loading
  },
  data() {
    return {
      loading: null,
      order: null,
      email: null,
      error: null
    }
  },
  created() {
    this.loading = true

    const body = {
      uid: this.$route.query['uid'],
      data: this.$route.query['d']
    }

    axios.post('payorder/create', body)
      .then(
        response => {
          this.loading = false
          this.order = response.data
          this.email = this.order.email
        },
        error => {
          this.loading = false
          this.error = error
        }
      )
  },
  methods: {
    submit() {
      const body = {
        uid: this.order.uid,
        email: this.email || this.order.email
      }

      axios.post('payorder/process', body)
        .then(
          response => {
            window.location = response.data.redirect_url
          },
          error => {
            if (error.response && error.response.data) {
              this.error = error.response.data['message'] || error
            } else {
              this.error = error
            }
          }
        )
    }
  }
}
</script>

<style lang="stylus" scoped>
  .order
    display: flex
    flex-direction: column
    flex-grow: 1

  .order-wrapper
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    height: 100%
    padding: 20px 30px
    text-align: center
    flex-grow: 1

  .title
    font-size: 70px
    font-weight: bold !important
    border-bottom: 3px solid #F8C922

  .subtitle
    margin: 25px 0

  .price
    background: #F5F5F5
    border: 1px solid #EAEAEA
    padding: 25px
    margin: 2% 0px
    border-radius: 15px
    width: 80%
    max-width: 700px
    align-items: center
    text-align: center

    .sum
      font-weight: bold
      font-size: 30px

    .info
      padding-top: 10px

  .success
    margin: 10px
    text-align: center

    img
      display: block
      margin: 20px auto

  .error
    font-size: 24px
    margin: 40px 0
    text-align: center

    .message
      color: #F8C922

    img
      display: block
      margin: 40px auto

    .info
      color: #665
      max-width: 500px
      margin-top: 40px
      line-height: 33px
      a
        color: inherit
        text-decoration: none
        &:hover
          text-decoration: underline

  .descr
    font-size: 24px
    margin: 20px 0

  .licensed
    margin: 20px 0
    input
      border: 1px solid #EAEAEA
      border-radius: 3px
      margin: 0 10px
      padding: 10px 10px
      width: 280px
      &.invalid
        border: 1px solid red
    .input-error
      padding-top: 10px;
      padding-left: 0px;
      font-size: 12px;

  .subscribe
    margin: 40px 0
    button
      font-size: 24px
      font-weight: bold
      padding: 25px 80px
      background: #F8C922
      border: 0
      border-radius: 15px
      &:hover
        background: #FFC700
      &:disabled
        background: #eadca8

  .processed-by
    margin: 20px 10px
    text-align: center
    img
      padding: 10px

  .loading-error
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    flex-grow: 1
</style>
